import { logImageError } from '../api/imageErrors';

export default {
  methods: {
    handleImageError(event, page) {
      const imageUrl = event.target && event.target.src;
      const apptoken = this.$store && this.$store.getters.apptoken;
      logImageError({ page, imageUrl, apptoken });
    },
  },
};
